// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"results_wrapper__2LW8H","value":"results_value__1PN81","label":"results_label__5cKyn","element":"results_element__2iPOp"};